import React, { Component } from "react";

import ShopList from "./panel/ShopList";

class Menu extends Component {
  toogleNavigationVisible = (event) => {
    const body = document.querySelector('body');
    if (!body || !body.classList) return;
    if (event.code && event.code !== 'Space') return;

    const need_close = body.classList.contains('navigation_visible');
    const navigation = document.querySelector('.if6_navigation>div');
    if (!need_close && navigation) {
      navigation.scrollTo(0, 0);
      document.querySelectorAll('.if6_navigation div div div').forEach(div => {
        div.classList.remove('navvisible');
      });
      const activeElements = document.querySelectorAll('.if6_navigation li.active>div');
      activeElements.forEach(div => {
        div.classList.add('navvisible');
      });
      const count = activeElements.length;
      const navContainer = document.querySelector('.if6_navigation>div>div');
      if (count > 0 && navContainer) {
        navContainer.style['left'] = `-${navContainer.clientWidth}px`;
      }
    }
    body.classList.toggle("navigation_visible");
  };

  render() {
    return (
      <div role="navigation" aria-label="Auswahl der Shops">
        <div className="iconbar"></div>
        <div className="if6_navigation">
          {" "}
          <button
            aria-label="Öffnet den Menübereich der Seite"
            onClick={this.toogleNavigationVisible}
            onKeyDown={this.toogleNavigationVisible}
          >
            <span className="if6_navigation" title="Alle Themen">
            </span>
          </button>
          <div>
            <ShopList><h2 aria-level="1">Alle Themen</h2></ShopList>
          </div>
        </div>
      </div>
    );
  }
}
export default Menu;
